// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/add_to_desktop.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/add_to_desktop_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../statics/add_to_desktop_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddToHomeScreenButton_add_to_desktop__xWxw0 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 47px;
    height: 47px;
    border-radius: 6px;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
    transition: background 0.5s;
}

.AddToHomeScreenButton_add_to_desktop__xWxw0::before {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.AddToHomeScreenButton_add_to_desktop__xWxw0::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.AddToHomeScreenButton_add_to_desktop__xWxw0:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
}

.AddToHomeScreenButton_add_to_desktop__xWxw0:active {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/AddToHomeScreenButton/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,gFAAsF;IACtF,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,gFAA4F;IAC5F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gFAA6F;IAC7F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gFAA4F;AAChG;;AAEA;IACI,gFAA6F;AACjG","sourcesContent":[".add_to_desktop {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 47px;\n    height: 47px;\n    border-radius: 6px;\n    font-size: 14px;\n    color: #fff;\n    cursor: pointer;\n    background: url('../../../../statics/add_to_desktop.png') no-repeat center / 100% 100%;\n    transition: background 0.5s;\n}\n\n.add_to_desktop::before {\n    content: \"\";\n    background: url('../../../../statics/add_to_desktop_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.add_to_desktop::after {\n    content: \"\";\n    background: url('../../../../statics/add_to_desktop_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.add_to_desktop:hover {\n    background: url('../../../../statics/add_to_desktop_hover.png') no-repeat center / 100% 100%;\n}\n\n.add_to_desktop:active {\n    background: url('../../../../statics/add_to_desktop_active.png') no-repeat center / 100% 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"add_to_desktop": `AddToHomeScreenButton_add_to_desktop__xWxw0`
};
export default ___CSS_LOADER_EXPORT___;
